export const maxPlayers = 8
export const maxPlayersDefault = 4
export const minPlayers = 2
export const minPlayersDefault = 2

export const defaultGameRoom = "game"

export const minBet = 50
export const defaultBet = 100

export const minMultiplyBet = 10
export const defaultMultiplyBet = 20

export const periodOnline = 10000

export const defaultDeckSize = 36

export const cardsPerPlayer = 6

export const tossCardsCountBeforeFirstBeat = 5
export const tossCardsCountAfterFirstBeat = 6

export const maxCardPosition = 5
